import { render } from "./MonthLocks.vue?vue&type=template&id=15bbf952&scoped=true"
import script from "./MonthLocks.vue?vue&type=script&lang=js"
export * from "./MonthLocks.vue?vue&type=script&lang=js"

import "./MonthLocks.vue?vue&type=style&index=0&id=15bbf952&lang=scss&scoped=true"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bbf952"]])

export default __exports__